//Materialize
import '../stylus/soporte.sass'


//FontAwsome
import '../libs/fontawsome/css/fontawesome-all.min.css'
import '../libs/open-sans.css'

import {initAll, initBuscador} from './include/global.js'

/** Dependencia de boostrap **/
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/offcanvas';

//modernizr
import '../libs/modernizr/modernizr-custom.js'
$(document).ready(function(){
	initAll();
	initBuscador();

	import("scriptjs").then((module) => {
		const $script = module.default;
		$script("https://www.google.com/recaptcha/api.js?render=6LdxY50UAAAAAHpijDbmVg2cGb2unL7NEZ5wQnZD");
	});
})